"use client";
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Tooltip } from 'react-tippy';
import { waitForSelector } from '../../utils/poll.js';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class Poptip extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "componentDidMount", () => {
      waitForSelector("body").then((documentBody) => {
        this.setState({ bodyDefined: !!documentBody });
      });
    });
    __publicField(this, "renderPoptip", () => {
      const {
        children,
        className,
        content,
        delay,
        disable,
        hideDelay,
        isAnimated,
        isInline,
        position,
        theme,
        trigger,
        ...props
      } = this.props;
      const wrapperInline = classNames({
        "display--inline": isInline
      });
      return /* @__PURE__ */ jsx(
        Tooltip,
        {
          arrow: true,
          className,
          delay: [delay, hideDelay],
          disabled: disable,
          ...!isAnimated ? { duration: 0 } : {},
          html: /* @__PURE__ */ jsx("div", { className: "force-break", children: content }),
          position,
          theme,
          trigger,
          ...props,
          children: /* @__PURE__ */ jsx("div", { className: wrapperInline, title: "", children })
        }
      );
    });
    this.state = {
      bodyDefined: typeof document !== "undefined" && !!document.body
    };
  }
  render() {
    if (this.state.bodyDefined) {
      return this.renderPoptip();
    }
    return null;
  }
}
// trigger prop left out as Trigger default, 'mouseenter focus', will be used
__publicField(Poptip, "defaultProps", {
  delay: 0,
  disable: false,
  hideDelay: 0,
  isAnimated: true,
  isInline: false,
  position: "top",
  theme: "dark"
});
__publicField(Poptip, "displayName", "Poptip");
__publicField(Poptip, "propTypes", {
  /** Content that, when hovered on, makes the Poptip appear */
  children: PropTypes.node.isRequired,
  /** CSS class names. */
  className: PropTypes.string,
  /** content could be a node of a string */
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  /** how long it takes after a trigger event is fired for a tooltip to show |
   * default => 0 */
  delay: PropTypes.number,
  /** disable value | default => false */
  disable: PropTypes.bool,
  /** how long it takes after a trigger event is fired for a tooltip to hide |
   * default => 0 */
  hideDelay: PropTypes.number,
  /** should the poptip content be animated | default => true */
  isAnimated: PropTypes.bool,
  /** should the poptip be displayed inline */
  isInline: PropTypes.bool,
  /** position value options | default => top */
  position: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  /** background color | default => dark */
  theme: PropTypes.oneOf(["dark", "light", "transparent"]),
  /** trigger value options | default => mouseenter focus */
  trigger: PropTypes.oneOf(["mouseenter", "focus", "click", "manual"])
});

export { Poptip as default };
